import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "flex items-center justify-between mb-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "mr-0 text-subtitle1" }, "Manifest Anda", -1)
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  focusable: "false",
  class: "w-5 h-5",
  style: {"-ms-transform":"rotate(180deg)","-webkit-transform":"rotate(180deg)","transform":"rotate(180deg)"},
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "#ffffff",
    d: "M19 11H7.14l3.63-4.36a1 1 0 1 0-1.54-1.28l-5 6a1.19 1.19 0 0 0-.09.15c0 .05 0 .08-.07.13A1 1 0 0 0 4 12a1 1 0 0 0 .07.36c0 .05 0 .08.07.13a1.19 1.19 0 0 0 .09.15l5 6A1 1 0 0 0 10 19a1 1 0 0 0 .64-.23a1 1 0 0 0 .13-1.41L7.14 13H19a1 1 0 0 0 0-2z"
  })
], -1)
const _hoisted_6 = {
  key: 0,
  class: "color-blue-grey text-sm font-semibold"
}
const _hoisted_7 = { class: "mx-auto" }
const _hoisted_8 = /*#__PURE__*/_createVNode("small", { class: "color-blue-grey text-center" }, "Semua", -1)
const _hoisted_9 = {
  key: 1,
  class: "color-blue-grey p-5 text-center"
}
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = { class: "w-full flex justify-end text-right mt-6" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Pending Barang")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_14 = { class: "grid gap-4 grid-cols-2 mb-4" }
const _hoisted_15 = { class: "p-field w-full" }
const _hoisted_16 = {
  key: 0,
  class: "p-error"
}
const _hoisted_17 = { class: "p-field w-full" }
const _hoisted_18 = {
  key: 0,
  class: "p-error"
}
const _hoisted_19 = { class: "p-field w-full mb-2" }
const _hoisted_20 = {
  key: 0,
  class: "p-error"
}
const _hoisted_21 = { class: "p-field w-full  mb-4" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", {
  for: "description",
  class: "text-body2"
}, "Keterangan", -1)
const _hoisted_23 = { class: "flex items-center justify-between" }
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "font-bold" }, "Grand Total", -1)
const _hoisted_25 = { class: "color-primary" }
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { class: "font-semibold pb-4 border-bottom-blue-grey-lighten-5" }, "Yang Disetorkan", -1)
const _hoisted_27 = { class: "flex items-center justify-between py-3 border-bottom-blue-grey-lighten-5" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    focusable: "false",
    class: "h-6 w-6 mr-2",
    style: {"-ms-transform":"rotate(360deg)","-webkit-transform":"rotate(360deg)","transform":"rotate(360deg)"},
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("g", { fill: "none" }, [
      /*#__PURE__*/_createVNode("path", {
        d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7z",
        stroke: "#607D8B",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      /*#__PURE__*/_createVNode("circle", {
        cx: "12",
        cy: "12",
        r: "3",
        stroke: "#607D8B",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M2 9v0a4 4 0 0 0 4-4v0",
        stroke: "#607D8B",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      /*#__PURE__*/_createVNode("path", {
        d: "M18 19v0a4 4 0 0 1 4-4v0",
        stroke: "#607D8B",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-semibold" }, "Tunai")
], -1)
const _hoisted_29 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_30 = { class: "flex items-center justify-between py-3" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    focusable: "false",
    class: "h-6 w-6 mr-2",
    style: {"-ms-transform":"rotate(360deg)","-webkit-transform":"rotate(360deg)","transform":"rotate(360deg)"},
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createVNode("g", { fill: "#607D8B" }, [
      /*#__PURE__*/_createVNode("path", { d: "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z" }),
      /*#__PURE__*/_createVNode("path", { d: "M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z" })
    ])
  ]),
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-semibold" }, "Non Tunai")
], -1)
const _hoisted_32 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "flex items-center justify-between p-4" }, [
  /*#__PURE__*/_createVNode("p", null, "Manifest")
], -1)
const _hoisted_34 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_35 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_36 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_37 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_38 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_39 = { class: "w-full mt-10 sm:mt-6 absolute bottom-0 left-0 right-0 px-6 py-6 bg-white" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Simpan & Print")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Batalkan")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Column = _resolveComponent("Column")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_InputText = _resolveComponent("InputText")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_DialogDetailResi = _resolveComponent("DialogDetailResi")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Card, { class: "card-no-shadow card-p-0 mb-8" }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode("div", _hoisted_4, [
              (_ctx.route.meta.permission.write)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: `p-button-outlined ${_ctx.data.length <= 0 ? 'p-button-secondary' : 'p-button-danger'} rounded-lg mr-2 flex items-center px-3 py-2 w-auto`,
                    disabled: _ctx.data.length <= 0,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDialogPending()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode("p", {
                        class: `${_ctx.data.length <= 0 ? 'color-blue-grey' : 'color-red'} text-xs mr-2`
                      }, "Pending", 2),
                      _createVNode("i", {
                        class: `pi pi-info-circle text-xs pr-3 sm:pr-1 ${_ctx.data.length <= 0 ? 'color-blue-grey' : 'color-red'}`
                      }, null, 2)
                    ]),
                    _: 1
                  }, 8, ["class", "disabled"]))
                : _createCommentVNode("", true),
              (_ctx.route.meta.permission.write && _ctx.checkDateDepature())
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    class: `${_ctx.data.length <= 0 ? 'p-button-secondary' : 'btn-primary'} text-white text-sm rounded-lg mr-0 px-1 py-1.5 sm:px-3`,
                    disabled: _ctx.data.length <= 0 || _ctx.selectedReceipt.length < _ctx.data.length,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDialogLoadingManifest()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode("p", {
                        class: `mr-0 ${_ctx.data.length <= 0 ? 'color-blue-grey-lighten-4' : 'text-white'} text-xs`
                      }, "Ke Loading Manifest", 2),
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["class", "disabled"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (!_ctx.checkDateDepature())
            ? (_openBlock(), _createBlock("p", _hoisted_6, "Jadwal masih belum hari ini / telah melewati batas toleransi, tidak bisa ke loading manifest"))
            : _createCommentVNode("", true)
        ]),
        (_ctx.data.length > 0)
          ? (_openBlock(), _createBlock(_component_DataTable, {
              key: 0,
              value: _ctx.data,
              class: "table-og body-td-x-0",
              responsiveLayout: "scroll"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, { header: "No" }, {
                  body: _withCtx((slotProps) => [
                    _createVNode("p", {
                      class: "font-semibold text-black px-4 h-14 flex items-center",
                      style: _ctx.activeStyle(slotProps.data.Id)
                    }, _toDisplayString(slotProps.index+1), 5)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { header: "Nomor Resi" }, {
                  body: _withCtx((slotProps) => [
                    _createVNode("p", {
                      class: "text-black font-semibold px-4 h-14 flex items-center hover-primary cursor-pointer",
                      onClick: ($event: any) => (_ctx.detail(slotProps.data)),
                      style: _ctx.activeStyle(slotProps.data.Id)
                    }, _toDisplayString(slotProps.data.Resi), 13, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { header: "Total Barang" }, {
                  body: _withCtx((slotProps) => [
                    _createVNode("p", {
                      class: "text-black font-semibold px-4 h-14 flex items-center",
                      style: _ctx.activeStyle(slotProps.data.Id)
                    }, _toDisplayString(slotProps.data['TransPengirimanDetails@odata.count']), 5)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, null, {
                  body: _withCtx((slotProps) => [
                    _createVNode("div", {
                      class: "px-4 h-14 flex items-center",
                      style: _ctx.activeStyle(slotProps.data.Id)
                    }, [
                      _createVNode("i", {
                        class: "pi pi-ellipsis-h text-base cursor-pointer ml-auto text-black",
                        "aria:haspopup": "true",
                        "aria-controls": "overlay_panel",
                        onClick: ($event: any) => (_ctx.showDropDown($event, slotProps.data))
                      }, null, 8, ["onClick"])
                    ], 4)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { style: {"text-align":"center"} }, {
                  header: _withCtx(() => [
                    _createVNode("div", _hoisted_7, [
                      _createVNode("div", null, [
                        _createVNode(_component_Checkbox, {
                          binary: true,
                          disabled: !_ctx.route.meta.permission.write,
                          modelValue: _ctx.checkedAllValue,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.checkedAllValue = $event)),
                          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.checkedAll())),
                          class: "checkbox-primary"
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _hoisted_8
                    ])
                  ]),
                  body: _withCtx((slotProps) => [
                    _createVNode("div", {
                      class: "mx-auto px-4 h-14 flex items-center",
                      style: _ctx.activeStyle(slotProps.data.Id)
                    }, [
                      _createVNode(_component_Checkbox, {
                        binary: true,
                        disabled: !_ctx.route.meta.permission.write,
                        modelValue: slotProps.data.checked,
                        "onUpdate:modelValue": ($event: any) => (slotProps.data.checked = $event),
                        onChange: ($event: any) => (_ctx.changeChecked(slotProps.data.Id, slotProps.data.checked)),
                        class: "checkbox-primary mx-auto"
                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])
                    ], 4)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]))
          : (_openBlock(), _createBlock("p", _hoisted_9, "Tidak Ada Barang Pada Manifest"))
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      header: `Pending Pengiriman Barang`,
      visible: _ctx.dialogPending,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogPending = $event)),
      class: "dialog-voucher",
      modal: true,
      dismissableMask: true,
      onHide: _cache[9] || (_cache[9] = ($event: any) => (_ctx.hideDialogPending()))
    }, {
      default: _withCtx(() => [
        _createVNode("form", {
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submitPendingManifest(!_ctx.vPend$.$invalid)), ["prevent"]))
        }, [
          _createVNode(_component_Textarea, {
            modelValue: _ctx.vPend$.description.$model,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.vPend$.description.$model = $event)),
            rows: "5",
            placeholder: "Tulis Alasan Anda",
            class: "w-full textarea-grey rounded-lg input-primary"
          }, null, 8, ["modelValue"]),
          ((_ctx.vPend$.description.$invalid && _ctx.submittedPend) || _ctx.vPend$.description.$pending.$response)
            ? (_openBlock(), _createBlock("small", _hoisted_10, _toDisplayString(_ctx.vPend$.description.required.$message), 1))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_Button, {
              class: "btn-primary text-black mr-3 px-5 sm:px-10 py-1 justify-center",
              type: "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              class: "btn-secondary text-black px-5 sm:px-10 py-1 justify-center",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hideDialogPending()))
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      header: `Tambah Loading Manifest`,
      visible: _ctx.dialogLoadingManifest,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => (_ctx.dialogLoadingManifest = $event)),
      class: "dialog-voucher relative",
      modal: true,
      dismissableMask: true,
      onHide: _cache[17] || (_cache[17] = ($event: any) => (_ctx.hideDialogLoadingManifest()))
    }, {
      default: _withCtx(() => [
        _createVNode("form", {
          id: "form-add-manifest",
          class: "mb-14",
          onSubmit: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.submitLoadingManifest(!_ctx.v$.$invalid)), ["prevent"]))
        }, [
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode("label", {
                for: "noPol",
                class: {'p-error':_ctx.v$.noPol.$invalid && _ctx.submitted, 'text-body2': true}
              }, "Nomor Polisi Bus", 2),
              _createVNode(_component_InputText, {
                id: "noPol",
                class: "input-primary w-full mt-1 uppercase rounded-lg",
                name: "noPol",
                modelValue: _ctx.v$.noPol.$model,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.noPol.$model = $event)),
                type: "text"
              }, null, 8, ["modelValue"]),
              _createVNode("div", null, [
                ((_ctx.v$.noPol.$invalid && _ctx.submitted) || _ctx.v$.noPol.$pending.$response)
                  ? (_openBlock(), _createBlock("small", _hoisted_16, _toDisplayString(_ctx.v$.noPol.required.$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("label", {
                for: "driverName",
                class: {'p-error':_ctx.v$.driverName.$invalid && _ctx.submitted, 'text-body2': true}
              }, "Nama Supir", 2),
              _createVNode(_component_InputText, {
                id: "driverName",
                class: "input-primary w-full mt-1 rounded-lg",
                name: "driverName",
                modelValue: _ctx.v$.driverName.$model,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.driverName.$model = $event)),
                type: "text"
              }, null, 8, ["modelValue"]),
              _createVNode("div", null, [
                ((_ctx.v$.driverName.$invalid && _ctx.submitted) || _ctx.v$.driverName.$pending.$response)
                  ? (_openBlock(), _createBlock("small", _hoisted_18, _toDisplayString(_ctx.v$.driverName.required.$message), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_19, [
            _createVNode("label", {
              for: "stewardName",
              class: {'p-error':_ctx.v$.stewardName.$invalid && _ctx.submitted, 'text-body2': true}
            }, "Nama Pramugara", 2),
            _createVNode(_component_InputText, {
              id: "stewardName",
              class: "input-primary w-full mt-1 rounded-lg",
              name: "stewardName",
              modelValue: _ctx.v$.stewardName.$model,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.v$.stewardName.$model = $event)),
              type: "text"
            }, null, 8, ["modelValue"]),
            _createVNode("div", null, [
              ((_ctx.v$.stewardName.$invalid && _ctx.submitted) || _ctx.v$.stewardName.$pending.$response)
                ? (_openBlock(), _createBlock("small", _hoisted_20, _toDisplayString(_ctx.v$.stewardName.required.$message), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_Textarea, {
              class: "input-primary w-full mt-1 rounded-lg",
              rows: "2",
              name: "description",
              modelValue: _ctx.dataAdd.description,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.dataAdd.description = $event)),
              type: "text"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_Card, { class: "card-no-shadow card-item-category mb-4" }, {
            content: _withCtx(() => [
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode("p", null, [
                  _createVNode("b", _hoisted_25, "Rp " + _toDisplayString(new Number(_ctx.detailAdd.PendapatanManifest).toLocaleString('id-ID')), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Card, { class: "card-no-shadow card-item-category mb-4" }, {
            content: _withCtx(() => [
              _hoisted_26,
              _createVNode("div", _hoisted_27, [
                _hoisted_28,
                (_ctx.detailAdd.DetailPembayaran)
                  ? (_openBlock(), _createBlock("p", _hoisted_29, "Rp " + _toDisplayString(new Number(_ctx.detailAdd.DetailPembayaran.Tunai).toLocaleString('id-ID')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_30, [
                _hoisted_31,
                (_ctx.detailAdd.DetailPembayaran)
                  ? (_openBlock(), _createBlock("p", _hoisted_32, "Rp " + _toDisplayString(new Number(_ctx.detailAdd.DetailPembayaran.NonTunai).toLocaleString('id-ID')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Card, { class: "card-no-shadow card-p-0 card-item-category mb-4" }, {
            header: _withCtx(() => [
              _hoisted_33
            ]),
            content: _withCtx(() => [
              (_ctx.detailAdd.Manifest)
                ? (_openBlock(), _createBlock(_component_DataTable, {
                    key: 0,
                    value: _ctx.detailAdd.Manifest,
                    class: "table-og body-td-x-0",
                    responsiveLayout: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Column, { header: "No" }, {
                        body: _withCtx((slotProps) => [
                          _createVNode("p", _hoisted_34, _toDisplayString(slotProps.index+1), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, { header: "Nomor Resi" }, {
                        body: _withCtx((slotProps) => [
                          _createVNode("p", _hoisted_35, _toDisplayString(slotProps.data.Resi), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, { header: "Jml Koli" }, {
                        body: _withCtx((slotProps) => [
                          _createVNode("p", _hoisted_36, _toDisplayString(slotProps.data.Jumlah), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, { header: "Pendapatan" }, {
                        body: _withCtx((slotProps) => [
                          _createVNode("p", _hoisted_37, "Rp " + _toDisplayString(new Number(slotProps.data.GrandTotal).toLocaleString('id-ID')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, { header: "Pembayaran" }, {
                        body: _withCtx((slotProps) => [
                          _createVNode("p", _hoisted_38, _toDisplayString(slotProps.data.JenisPembayaran), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 32),
        _createVNode("div", _hoisted_39, [
          _createVNode(_component_Button, {
            class: "btn-primary text-black mr-3 sm:px-10 px-4 py-1 text-sm sm:text-base",
            type: "submit",
            form: "form-add-manifest"
          }, {
            default: _withCtx(() => [
              _hoisted_40
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "btn-secondary text-black sm:px-10 px-4 py-1 text-sm sm:text-base",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.hideDialogLoadingManifest()))
          }, {
            default: _withCtx(() => [
              _hoisted_41
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_OverlayPanel, {
      ref: "op",
      id: "overlay_panel"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          refund: _ctx.route.meta.permission.update && _ctx.$checkIsRefund(_ctx.idManifest.TransPengirimanDetails),
          detail: true,
          onRefund: _cache[18] || (_cache[18] = ($event: any) => (_ctx.refund(_ctx.idManifest))),
          onDetail: _cache[19] || (_cache[19] = ($event: any) => (_ctx.detail(_ctx.idManifest)))
        }, null, 8, ["refund"])
      ]),
      _: 1
    }, 512),
    (_ctx.showDialogDetail)
      ? (_openBlock(), _createBlock(_component_DialogDetailResi, {
          key: 0,
          isRefund: _ctx.isRefund,
          idTrans: _ctx.idManifest.Id,
          isShowDialog: _ctx.showDialogDetail,
          onReloadData: _cache[20] || (_cache[20] = ($event: any) => (_ctx.getAllData())),
          onHideDialog: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showDialogDetail = false))
        }, null, 8, ["isRefund", "idTrans", "isShowDialog"]))
      : _createCommentVNode("", true)
  ]))
}